import { Pagination, Avatar, Box, Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useAdminListMutation } from "../../redux/Admin/Admin.api";
import { useContext, useEffect, useState } from "react";
import MUIButton from "../../reusable_components/components/MUIButton";
import { Link, useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import './admin.css'
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import { TableLoader } from "../../reusable_components/components/TableLoader";
import SearchIconLg from "../../assets/Icons/SearchIcon";

const Admin = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [userName, setUserName] = useState(commonFilter?.admin?.userName || "")

    const navigate = useNavigate()

    const { Snackbar } = useContext(SnackbarContext)
    const [showTableLoader, setShowTableLoader] = useState(false)

    const [adminList, setAdminList] = useState([])
    const [count, setCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(+localStorage.getItem("adminNewPage") || 1);

    // APIs
    const [AdminList] = useAdminListMutation()

    const handleChangePage = (event, newPage) => {
        localStorage.setItem("adminNewPage",newPage)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleSearchKeywordChange = (e) => {
        setPage(1)
        const value = e.target.value
        setUserName(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        // 2. Update the clientId inside dashbord
        const updatedFilter = {
            ...currentFilter,
            admin: {
                ...currentFilter.userName,
                userName: value
            }
        };

        // 3. Store the updated object back in localStorage
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    useEffect(() => {
        const viewAdminList = async () => {
            try {
                const payload = {
                    page: (page - 1),
                    size: rowsPerPage,
                    userName: userName || ""
                }
                setShowTableLoader(true)
                const response = await AdminList(payload).unwrap()
                setShowTableLoader(false)
                setAdminList(response?.response?.data);
                setCount(response?.response?.Count);

            } catch (error) {
                Snackbar("Netwok error", 'error')
                setShowTableLoader(false)
            }
        }
        viewAdminList()
    }, [rowsPerPage, page, userName])

    const navigateAdminUpdate = (item) => {
        navigate(`/view-admin/co-ordinators/${item.id}`, {
            state: { type: +item?.type }
        }
        )
    }

    const filteredTableDatas = adminList?.filter((item) => {
        return (
            (item?.firstName?.toLowerCase()?.startsWith(userName?.toLowerCase()))
        )
    })

    return (
        <Box className="container">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography className="title">Admin/Co-ordinator</Typography>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <Grid2 item>
                        <TextField
                            value={userName}
                            onChange={handleSearchKeywordChange}
                            placeholder="Search Admin/Co-ordinator"
                            className="textfields"
                            slotProps={{
                                input: {
                                    startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                }
                            }}
                        />
                    </Grid2>
                    <MUIButton startIcon={<AddIcon />} title="Add Admin" component={Link} to="/add-admin" sx={{ backgroundColor: '#7F56D9', width: '130px' }}></MUIButton>
                </div>
            </div>
            <Grid2>
                <Paper sx={{ width: '100%', overflow: 'auto', marginTop: '25px', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell className='tableHeadersCell'> Id   </TableCell> */}
                                <TableCell className='tableHeadersCell'> Name</TableCell>
                                <TableCell className='tableHeadersCell'> User Type</TableCell>
                                <TableCell className='tableHeadersCell'> Email/Phone</TableCell>
                                <TableCell className='tableHeadersCell'> City</TableCell>
                                <TableCell className='tableHeadersCell'> Status</TableCell>

                            </TableRow>
                        </TableHead>
                        {!showTableLoader ? (
                            filteredTableDatas?.length > 0 ? (
                                <TableBody>
                                    {filteredTableDatas?.map((item, index) => {
                                        const firstLetter = item?.firstName
                                        const letter = firstLetter?.charAt(0)?.toUpperCase()
                                        const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                        const backgroundColor = colors[index % colors?.length]
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                    '&:hover': { backgroundColor: '#f1f1f1' },
                                                }}
                                                onClick={(e) => navigateAdminUpdate(item)}
                                            >
                                                {/* <TableCell className='tableBodyCell' sx={{ color: '#53389E', cursor: 'pointer', fontWeight: 600 }}
                                                  >{item.id}</TableCell> */}
                                                <TableCell className='tableBodyCell'>
                                                    <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center', color: '#535862', cursor: 'pointer', }}>
                                                        <Avatar sx={{ backgroundColor: backgroundColor, width: 30, height: 30, fontSize: '14px' }}>{letter}</Avatar>
                                                        <span style={{ color: "#6941C6", fontWeight: "bold", fontSize: "14px", fontWeight: 600 }}>
                                                            {item?.firstName} {item?.lastName}
                                                        </span>
                                                    </Box>

                                                </TableCell>
                                                <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{+item?.type ? "Admin" : "Coordinator"}</TableCell>
                                                <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item?.email}/ {item.mobile}</TableCell>
                                                <TableCell className='tableBodyCell' sx={{ color: '#181D27' }}>{item?.city}</TableCell>
                                                <TableCell className='tableBodyCell'>
                                                    <span className={`adminStatus-badge ${+item?.status ? "active" : "inactive"}`}>
                                                        {+item?.status ? "Active" : "Inactive"}
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            ) : (<TableBody>
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <Typography className="emptydatas">No Data Found</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(count / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handleChangePage(null, page - 1)}
                                            sx={{ height: '36px' }}
                                            disabled={page === 1}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handleChangePage}
                                            count={Math.ceil(count / rowsPerPage)}
                                            shape='rounded'
                                            boundaryCount={0}
                                            siblingCount={0}
                                            hideNextButton
                                            hidePrevButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            onClick={() => handleChangePage(null, page + 1)}
                                            disabled={page === Math.ceil(count / rowsPerPage)}
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>
                {/* <TablePagination
                    className="tablepagination"
                    rowsPerPageOptions={[10, 15, 20]}
                    component="div"
                    count={count || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
            </Grid2>
        </Box>
    )
}
export default Admin;